import { intakeStatusLabel } from "@/models/intakeStatus";

// An order whose order form has not arrived yet: the drug comes with the order fax that follows.
export const AWAITING_ORDER = "Awaiting order";

const startedOn = (value) =>
  value ? new Date(value).toLocaleDateString("en-US", { month: "short", day: "numeric" }) : "";

/** The row title: what the screen calls an order, its number and its drug. */
export const orderTitle = (order, noun = "Order") => `${noun} #${order.id} · ${order.drugName || AWAITING_ORDER}`;

/** The drug an order form names, as the order screens read it: the first therapy, else the client's own key. */
export const drugNameOf = (orderForm) =>
  orderForm?.therapyAdministration?.[0]?.name || orderForm?.extraData?.additionalDrugName || null;

/** The step the order waits at and when it started. */
export const orderMeta = (order) => `${intakeStatusLabel(order.status)} · started ${startedOn(order.createdOn)}`;

/** The rows a fax may be joined to: an order with no open step is refused by the submit. */
export const attachableOrders = (rows) => rows.filter((order) => order.canTakeFax);

/** Non-blocking: the order names another drug than what the operator is filing onto it. */
export const drugWarning = (order, subject, subjectDrug) => {
  if (!subjectDrug || !order.drugName || order.drugName === subjectDrug) return "";
  return `Different drug than ${subject} (${subjectDrug}) — make sure these are the same order`;
};
